import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Domain extends Component {
  constructor() {
    super(...arguments);

    this.state = {
      selected: false
    };
  };

  render() {
    const {
      domain,
      listPrice,
      salePrice,
      extendedValidation,
      disclaimer
    } = this.props.domainResult;

    const {
      text,
      cartClick
    } = this.props;

    let content;

    if (this.state.selected) {
      content = (
        <div className="rstore-message">
          <span className="dashicons dashicons-yes rstore-success"></span>
          <button className="buttselected" onClick={ ()=>cartClick(this) }>{ text.selected }</button>
        </div>
      );
    }
    else {
      content = (
        <div className="rstore-message">
          { listPrice !== salePrice && <span className="listPrice"><small><s>{ listPrice }</s></small></span> }
           <button className="salePrice" onClick={ ()=>cartClick(this) }><strong>{ salePrice}{extendedValidation && '*' }</strong></button>
        </div>
      );
    }

    if (domain && listPrice) {
      return (
        
        <li className="available" style={{'min-width': '98%'}}>
          <h4>
            { domain }
            <span className="rstore-disclaimer"><pre>{ disclaimer }</pre></span>
          </h4>
          <div className="price">
            { content }
          </div>
        </li>
        
      );
    }

    return(<div></div>);
  }
}

Domain.propTypes = {
  domainResult: PropTypes.object.isRequired,
  text: PropTypes.object.isRequired,
  cartClick: PropTypes.func.isRequired
}
